<template>

    <div>
        <app-header></app-header>

        <div class="columns">
            <!-- left column, the share -->
            <div class="column"
                id="share-root"
            >
                <section class="hero">
                    <div class="hero-body">
                        <h1 class="title">
                            <router-link :to="{ name: 'share', params: {uuid: reviewableshare.uuid} }">
                                {{ reviewableshare.title }}
                                <b-icon
                                    icon="open-in-new"
                                    size="is-small">
                                </b-icon>
                            </router-link>
                        </h1>
                        <h2 class="subtitle">
                            {{ reviewableshare.date_created | relative_datetime}}
                        </h2> 
                    </div>
                    <rev-card-container :reviewables="reviewables"></rev-card-container>
                </section>
            
                
            </div>
            
            <!-- right column - the notes -->
            <div v-if="notes_loaded" class="column">
                <note-card-container :notes="notes"></note-card-container>
            </div>

        </div>
       
    </div>

</template>

<script>
    import axios from 'axios'

    import { date_filters } from '../mixins/Filters'

    export default {
        mixins: [date_filters],
        data() {
            return {
                // Set data propertie from the router (routes.js)
                share_id: this.$route.params.id,

                // Data properties for the den api
                reviewableshare: {},
                reviewables: [],
                notes: Array,
                notes_loaded: false,
            }
        },
        // watch to see if router has changed, update uuid
        watch: {
            '$route'(to, from){
                this.share_id = to.params.id
            }
        },
        methods: {
            GetReviewablesFromShare() { // DRY from ReviewableShare
                // loop through the reviewables in the requested reviewableshare object
                // reviewableshare api used to be URL
                this.reviewableshare.reviewables.forEach(reviewable_id => {
                    let reviewable_api = window.location.origin + '/api/reviewables/' + reviewable_id + '/?format=json'

                    axios
                        .get(reviewable_api)
                        .then(response => {
                            this.reviewables.push(response.data)
                        })
                        .catch(error => console.log(error))
                })
            },
            GetReviewableShare() { // similar to get reviewables
                // Use the URL rather than the filter for ID
                // var resturl = window.location.origin + '/api/reviewableshares/' + this.share_id + '/?format=json'
                if (process.env.NODE_ENV == 'development') {
                    console.info("this.share_id", this.share_id)
                }

                // filter by UUID
                var resturl = window.location.origin + '/api/reviewableshares/' + this.share_id + '/?format=json'

                axios
                    .get(resturl)
                    .then(response => {
                        if (process.env.NODE_ENV == 'development') {
                            console.info('response', response)
                        }
                        
                        // not sure why different to reviewableshare.vue
                        this.reviewableshare = response.data

                        // then get the reviewables from the API, reviewableshares only store the URLs
                        this.GetReviewablesFromShare()
                    })
                    .catch(error => console.log(error))
            },
            GetNotes() {
                let resturl = window.location.origin + '/api/notes/?source_share=' + this.share_id + '&format=json'

                axios
                    .get(resturl)
                    .then(response => {
                        if (process.env.NODE_ENV == 'development') {
                            console.info('response', response)
                        }
                        this.notes = response.data.results
                        this.notes_loaded = true
                    })
                    .catch(error => console.log(error))
            },
        },
        mounted() { // once mounted (ie. wait for mounted)
            this.GetReviewableShare()
            this.GetNotes()
        },
    }
</script>


<style lang="scss" scoped>
    $light_bg : #dddbd4;
    
    #share-root {
        background-color: $light_bg;
        // margin: 2em 0 0 2em;
    }

    .columns {
        margin: 1em;
    }
</style>
